'use-strict';

/* @ngInject */
export default function TaskFormController(
  $scope,
  // toastService,
  // $location,
  // monitoringApiService,
  // dateService,
) {
  $scope.task = {
    title: '',
    description: '',
    task_actions: [],
    notifications: {
      task: {
        mail: false,
        autoboard: false,
      },
      creator_overdue: {
        mail: false,
        autoboard: false,
      },
      creator_closed: {
        mail: false,
        autoboard: false,
      },
    },
  };
  $scope.sending = false;

  /**
   * Add an element to the provided array.
   *
   * @param {Array} array
   */
  $scope.addElement = (array) => {
    array.push({});
  };

  $scope.removeElement = (array, criterionIndex) => {
    array.splice(criterionIndex, 1);
  };

  // $scope.saveTask = () => {
  //   if ($scope.task.assignedUsers === undefined || $scope.task.assignedUsers.length === 0) return toastService.toast('error', 'Es muss mindestes ein Benutzer ausgewählt werden.');
  //   $scope.sending = true;

  //   const task = {
  //     title: $scope.task.title,
  //     description: $scope.task.description,
  //     duedate: $scope.task.duedate !== undefined
  //       ? dateService.convertToBackend($scope.task.duedate) : null,
  //     task_actions: $scope.task.task_actions.length === 0 ? null : $scope.task.task_actions,
  //     assignedUsers: $scope.task.assignedUsers.split(',').map((id) => parseInt(id, 10)),
  //     notifications: $scope.task.notifications,
  //   };

  //   monitoringApiService.apiCreateTask(task)
  //     .then((taskId) => {
  //       toastService.toast('success', 'Die Aufgabe wurde angelegt.');
  //       $location.path(`/tasks/task/${taskId}`);
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //       $scope.sending = false;
  //     });

  //   return null;
  // };
}
